/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import EditDiagramMenu from './EditDiagramMenu';
import chevronDown16 from '@ba/ba-graphics/dist/icons-js/chevron-down_16';
import chevronUp16 from '@ba/ba-graphics/dist/icons-js/chevron-up_16';
import { SVGIcon } from '@ba/ba-ui-carbon-toolkit';
import './editDiagram.scss';

class EditDiagramDropDown extends Component {

	constructor(props) {
		super(props);
		this.state = {
			open: false
		};
	}

	render() {
		const caret = this.renderCaret();
		return (
			<div className="edit-diagram-button-container"
				ref={node => this.el = node}
			>
				<div className="edit-diagram-dropdown-button"
					tabIndex={0}
					onKeyDown={(event) => this._onKeyDown(event)}
					onClick={(event) => this._onOpen(event)}
					onTouchEnd={(event) => this._onOpen(event)}
				>
					<span className="edit-diagram-dropdown-button__text">{StringResources.get('edit_diagram')}</span>
					{caret}
				</div>
				{this.state.open && this.renderMenu()}
			</div>
		);
	}

	renderCaret() {
		let id;
		if (this.state.open) {
			id = chevronUp16.id;
		} else {
			id = chevronDown16.id;
		}

		return (
			<div className="edit-diagram-dropdown-button__caret">
				<SVGIcon iconId={id} size="small" />
			</div>
		);
	}

	renderMenu() {
		const targetModel = this.props.relationshipVM.getTargetModel();
		return (
			<EditDiagramMenu
				triggerNode={this.el}
				targetModel={targetModel}
				onClose={this._onClose.bind(this)}
				onChangeScopeClick={this._onChangeScopeClick.bind(this)}
				isEditScopeFeatureEnabled={this.props.relationshipVM.isEditScopeFeatureEnabled()}
				dataState={this.props.relationshipVM.getTargetModel().data.state}
			>
			</EditDiagramMenu>
		);
	}

	_onKeyDown(event) {
		switch (event.key) {
			case ' ': // space
			case 'Enter':
				this._onOpen();
		}
	}

	_onOpen(event) {
		// Toggle the dropdown.
		this.setState({
			open: !this.state.open
		});
		if (event) {
			event.preventDefault();
		}
	}

	_onClose() {
		this.setState({
			open: false
		});
	}

	_onChangeScopeClick() {
		this.props.onChangeScopeClick();
	}
}

EditDiagramDropDown.propTypes = {
	relationshipVM: PropTypes.object.isRequired,
	onChangeScopeClick: PropTypes.func
};

export default EditDiagramDropDown;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/EditDiagramDropDown.js